module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "thebody"
    }
  }, [_c('lrHeader', {
    attrs: {
      "theHeader": _vm.headerMsg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods_wall"
  }, _vm._l((_vm.list), function(n) {
    return _c('div', {
      staticClass: "theleft"
    }, [_c('a', {
      attrs: {
        "href": ""
      }
    }, [_c('img', {
      attrs: {
        "src": n.image,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "clothesTitle"
    }, [_vm._v(_vm._s(n.title))]), _vm._v(" "), _c('div', {
      staticClass: "figcaption"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(n.price))]), _vm._v(" "), _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("star_border")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("cut")(n.cfav)))])])])])
  }))], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1a020e4a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1a020e4a","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/router/pmycollect.vue
// module id = 310
// module chunks = 0